import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, unref as _unref, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66dc5c33"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "▾", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "▾", -1))
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "×", -1))
const _hoisted_5 = [
  _hoisted_4
]

import { inject, nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import TokenMedia from '@/components/TokenMedia.vue';
import { useClaimStore } from '@/store/claimStore';

type ExpandableMediaProps = {
  disabledExpand?: boolean;
};

type Position = {
  x: number;
  y: number;
};

const MAX_ZOOM = 5;
const MIN_ZOOM = 1;
const SCROLL_SENSITIVITY = 0.005;

export default /*#__PURE__*/_defineComponent({
  __name: 'ExpandableMedia',
  props: {
    disabledExpand: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

_useCssVars(_ctx => ({
  "f1cf1116": (_unref(store).mediaBackground.colors?.[0] || "transparent")
}))



const store = useClaimStore();
const imageUrl: string = inject('image', '');
const expanded = ref(false);
const expandedShow = ref(false);
const fullscreen = ref<HTMLElement>();
const closeButton = ref<HTMLButtonElement>();

watch(expanded, (value: boolean) => {
  if (value) {
    cameraOffset.value = {
      x: window.innerWidth / 2,
      y: window.innerHeight / 2,
    };
    cameraZoom.value = 1;

    nextTick(() => {
      if (fullscreen.value) {
        expandedShow.value = true;
        fullscreen.value.focus();
      }
    });
  } else {
    expandedShow.value = false;
  }
});

onMounted(() => {
  window.addEventListener('keyup', close, false);
});

onBeforeUnmount(() => {
  window.removeEventListener('keyup', close);
});

const close = (e: KeyboardEvent) => {
  if (e.key === 'Escape') {
    expanded.value = false;
  }
};

const dragStart: Position = { x: 0, y: 0 };
const cameraOffset = ref<Position>({
  x: window.innerWidth / 2,
  y: window.innerHeight / 2,
});
const cameraZoom = ref(1);
let isDragging = false;
let initialPinchDistance: number | null = null;
let lastZoom = cameraZoom.value;

// Gets the relevant location from a mouse or single touch event
function getEventLocation(e: TouchEvent | MouseEvent): Position {
  if (e instanceof TouchEvent && e.touches && e.touches.length === 1) {
    return { x: e.touches[0].clientX, y: e.touches[0].clientY };
  } else if (e instanceof MouseEvent && e.clientX && e.clientY) {
    return { x: e.clientX, y: e.clientY };
  }
  return { x: 0, y: 0 };
}

function handleTouch(e: TouchEvent, singleTouchHandler: (e: TouchEvent) => void) {
  if (e.type === 'touchend' && e.target === closeButton.value) {
    expanded.value = false;
    return;
  }
  e.preventDefault();

  if (e.touches.length === 1) {
    singleTouchHandler(e);
  } else if (e.type === 'touchmove' && e.touches.length === 2) {
    isDragging = false;
    handlePinch(e);
  }
}

function handlePinch(e: TouchEvent) {
  e.preventDefault();

  const touch1 = { x: e.touches[0].clientX, y: e.touches[0].clientY };
  const touch2 = { x: e.touches[1].clientX, y: e.touches[1].clientY };

  // This is distance squared, but no need for an expensive sqrt as it's only used in ratio
  const currentDistance = (touch1.x - touch2.x) ** 2 + (touch1.y - touch2.y) ** 2;

  if (initialPinchDistance === null) {
    initialPinchDistance = currentDistance;
  } else {
    adjustZoom(null, currentDistance / initialPinchDistance);
  }
}

function adjustZoom(event: WheelEvent | null, zoomFactor: number | undefined) {
  if (event) {
    event.preventDefault();
  }

  let zoomAmount;
  let tempCameraZoom = cameraZoom.value;

  if (event) {
    zoomAmount = -event.deltaY * SCROLL_SENSITIVITY;
  }

  if (!isDragging) {
    if (zoomAmount) {
      tempCameraZoom += zoomAmount;
    } else if (zoomFactor) {
      tempCameraZoom = zoomFactor * lastZoom;
    }

    tempCameraZoom = Math.min(tempCameraZoom, MAX_ZOOM);
    tempCameraZoom = Math.max(tempCameraZoom, MIN_ZOOM);

    cameraZoom.value = tempCameraZoom;
  }
}

function onPointerDown(e: TouchEvent | MouseEvent) {
  e.preventDefault();
  isDragging = true;
  dragStart.x = getEventLocation(e).x / cameraZoom.value - cameraOffset.value.x;
  dragStart.y = getEventLocation(e).y / cameraZoom.value - cameraOffset.value.y;
}

function onPointerUp(e: TouchEvent | MouseEvent) {
  e.preventDefault();
  isDragging = false;
  initialPinchDistance = null;
  lastZoom = cameraZoom.value;
}

function onPointerMove(e: TouchEvent | MouseEvent) {
  e.preventDefault();
  if (isDragging) {
    cameraOffset.value.x = getEventLocation(e).x / cameraZoom.value - dragStart.x;
    cameraOffset.value.y = getEventLocation(e).y / cameraZoom.value - dragStart.y;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _mergeProps({ class: "manifold m-expandable-image" }, _ctx.$attrs), [
      _createVNode(TokenMedia),
      (!props.disabledExpand)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (expanded.value = true))
          }, _hoisted_3))
        : _createCommentVNode("", true)
    ], 16),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (expanded.value && _unref(imageUrl))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            ref_key: "fullscreen",
            ref: fullscreen,
            class: _normalizeClass(["m-expandable-image-expanded", { show: expandedShow.value }]),
            onWheel: _cache[2] || (_cache[2] = ($event: any) => (adjustZoom($event, undefined))),
            onMousedown: onPointerDown,
            onMousemove: onPointerMove,
            onMouseup: onPointerUp,
            onTouchstart: _cache[3] || (_cache[3] = ($event: any) => (handleTouch($event, onPointerDown))),
            onTouchmove: _cache[4] || (_cache[4] = ($event: any) => (handleTouch($event, onPointerMove))),
            onTouchend: _cache[5] || (_cache[5] = ($event: any) => (handleTouch($event, onPointerUp)))
          }, [
            _createVNode(TokenMedia, {
              class: "m-token-media",
              style: _normalizeStyle({
          top: `${cameraOffset.value.y}px`,
          left: `${cameraOffset.value.x}px`,
          transform: `translate3d(-50%, -50%, 0) scale(${cameraZoom.value})`,
        })
            }, null, 8, ["style"]),
            _createElementVNode("button", {
              ref_key: "closeButton",
              ref: closeButton,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (expanded.value = false))
            }, _hoisted_5, 512)
          ], 34))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}
}

})